var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHighNeed = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 35,
  height: 36,
  viewBox: "0 0 35 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.84541 35.5442V25.5606H0V18.507H10.648L14.3401 24.1499C14.4114 24.2584 14.472 24.3217 14.522 24.3398C14.5719 24.3579 14.6451 24.3669 14.7414 24.3669H14.9822C15.0178 24.3669 15.0892 24.3127 15.1962 24.2042L19.7978 12.9727L23.3293 18.29C23.3693 18.4025 23.4287 18.4669 23.5075 18.4832C23.5864 18.4991 23.6697 18.507 23.7574 18.507H34.673V25.5606H24.8276V35.5442H9.84541ZM14.8751 23.0105L11.3506 17.6536C11.2746 17.5353 11.2091 17.4671 11.1542 17.449C11.0996 17.4309 11.0201 17.4219 10.9156 17.4219H0V10.3683H9.84541V0.384766H24.8276V10.3683H34.673V17.4219H24.0249L20.3864 11.779C20.3204 11.6824 20.2477 11.6222 20.1681 11.5983C20.0889 11.5741 20.0051 11.562 19.9166 11.562H19.6908C19.6552 11.562 19.5838 11.6162 19.4768 11.7248L14.8751 23.0105Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHighNeed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/highNeed.8a1679221d3eaf72d6fb753887577d95.svg";